<!--LOADING-->
<ng-template [ngIf]="isLoading">
  <app-loading-page class="white-top-theme"></app-loading-page>
</ng-template>
<!--END LOADING-->
<!--QUICK START GUIDE-->
<ng-template [ngIf]="!isLoading">
  <section class="quick-start-guide margin-top-offset">
    <div class="wrapper">
      <!--QUICK START GUIDE CONTENT-->
      <div class="columns">
        <!--LEFT SIDE CONTENT-->
        <ng-container *ngIf="quickStartGuide; else unavailable">
          <div class="left-aside-column">
            <!--SHARED CMS STATIC PAGE-->
            <app-static-page
              [title]="quickStartGuide?.title"
              [bodyContent]="quickStartGuide.content | safe : 'html'">
            </app-static-page>
            <!--END SHARED CMS STATIC PAGE-->
          </div>
        </ng-container>
        <!--END LEFT SIDE CONTENT-->

        <!--RIGHT SIDE CONTENT-->
        <ng-container *ngIf="parentNavItems && parentNavItems.length > 0">
          <div class="right-aside-column">
            <app-aside-list-navigation
              [navItems]="parentNavItems"
              [childNavItems]="childNavItems"
              [slugname]="'training-support'">
            </app-aside-list-navigation>
          </div>
        </ng-container>
        <!--END RIGHT SIDE CONTENT-->
      </div>
      <!--END QUICK START GUIDE CONTENT-->
    </div>
  </section>
</ng-template>
<!--END QUICK START GUIDE-->
<ng-template #unavailable>
  <section>
    <p class="wrapper">
      Sorry for the inconvience. We are not able to load content at this time due to technical
      difficulties.
    </p>
  </section>
</ng-template>
